// src/components/auth/AuthButtons.js
import React, { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const AuthButtons = ({ showLogin }) => {
  const { currentUser, logout, loading } = useAuth();
  const [showMenu, setShowMenu] = useState(false);
  const menuRef = useRef(null);
  
  // Close menu when clicking outside
  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setShowMenu(false);
      }
    };
    
    document.addEventListener('mousedown', handleOutsideClick);
    return () => {
      document.removeEventListener('mousedown', handleOutsideClick);
    };
  }, []);
  
  const handleLogout = async () => {
    try {
      await logout();
      setShowMenu(false);
    } catch (error) {
      console.error('Logout error:', error);
    }
  };

  // If still loading auth state, show a spinner
  if (loading) {
    return (
      <div className="animate-pulse flex space-x-2">
        <div className="rounded-full bg-gray-700 h-8 w-8"></div>
        <div className="rounded bg-gray-700 h-8 w-20"></div>
      </div>
    );
  }

  // If logged in, show the user menu
  if (currentUser) {
    return (
      <div className="relative" ref={menuRef}>
        <button
          onClick={() => setShowMenu(!showMenu)}
          className="flex items-center px-4 py-2 rounded-lg text-gray-300 hover:text-white bg-gray-800 hover:bg-gray-700 border border-gray-700 focus:outline-none"
        >
          <span className="mr-2">{currentUser.username}</span>
          <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
            <path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 011.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd" />
          </svg>
        </button>
        
        {showMenu && (
          <div className="absolute right-0 mt-2 w-48 rounded-md shadow-lg bg-gray-800 border border-gray-700 z-10">
            <div className="py-1">
              <Link
                to="/profile"
                className="block px-4 py-2 text-sm text-gray-300 hover:bg-gray-700 hover:text-white"
                onClick={() => setShowMenu(false)}
              >
                Profile
              </Link>
              <Link
                to="/recommendations"
                className="block px-4 py-2 text-sm text-gray-300 hover:bg-gray-700 hover:text-white"
                onClick={() => setShowMenu(false)}
              >
                Recommendations
              </Link>
              <button
                onClick={handleLogout}
                className="block w-full text-left px-4 py-2 text-sm text-gray-300 hover:bg-gray-700 hover:text-white"
              >
                Sign out
              </button>
            </div>
          </div>
        )}
      </div>
    );
  }

  // Not logged in, show login and register buttons
  return (
    <div className="flex space-x-2">
      <button
        onClick={() => showLogin()}
        className="px-4 py-2 rounded-lg text-gray-300 hover:text-white bg-gray-800 hover:bg-gray-700 border border-gray-700 focus:outline-none"
      >
        Log in
      </button>
      <Link
        to="/register"
        className="px-4 py-2 rounded-lg text-white bg-blue-600 hover:bg-blue-700 border border-blue-700 focus:outline-none"
      >
        Register
      </Link>
    </div>
  );
};

export default AuthButtons;
